import React, { useEffect, useState } from "react";
import { storeStateType, useAppDispatch } from "../../redux/store";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Avatar,
  Button,
  CircularProgress,
  Grid,
} from "@mui/material";
import { TextField } from "@mui/material";
import {
  checkWorkLimit,
  loadWorktypeEmployee,
} from "../../redux/actions/schedule.actions";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import Modal from "@mui/material/Modal";
import {
  LOAD_LATEST_SELECTED_EVENT_DATA,
  LOAD_WORKTYPE_EMPLOYEES,
} from "../../redux/types/schedule.types";
import ModalBoxHeader from "../../components/ModalBoxHeader";
import SaveIcon from "@mui/icons-material/Save";
import { green } from "@mui/material/colors";

interface IEmployeeOption {
  name: string;
  id: string;
  email: string;
  avatar: string;
}

export type propsType = {
  setShowAssignEmployeeModal: React.Dispatch<React.SetStateAction<boolean>>;
  titleName: string;
};

export default function AssignEmployeeModal(props: propsType) {
  const dispatch = useAppDispatch();

  const { setShowAssignEmployeeModal, titleName } = props;
  const [selectedEmployee, setSelectedEmployee] =
    useState<IEmployeeOption | null>(null);

  const { loading, latestSelectedEventData } = useSelector(
    (store: storeStateType) => store.schedule
  );
  const [employeeOptions, setEmployeeOptions] = useState<any>([]);

  useEffect(() => {
    return () => {
      dispatch({ type: LOAD_WORKTYPE_EMPLOYEES, payload: [] });
      dispatch({ type: LOAD_LATEST_SELECTED_EVENT_DATA, payload: null });
    };
  }, [dispatch]);

  useEffect(() => {
    if (latestSelectedEventData)
      dispatch(loadWorktypeEmployee(latestSelectedEventData?.work_type));
  }, [dispatch, latestSelectedEventData]);

  function handleModalClose() {
    setShowAssignEmployeeModal(false);
  }
  const { worktype_employees } = useSelector(
    (state: storeStateType) => state.schedule
  );

  useEffect(() => {
    let wEmployee = worktype_employees?.map((employee) => {
      return {
        key: employee.id,
        email: employee.email,
        name: `${employee.fullname} `,
        id: employee.id,
        avatar: employee.avatar,
      };
    });
    setEmployeeOptions(wEmployee);
  }, [worktype_employees]);
  console.log("emplooyeee options", employeeOptions);
  // let employeeOptions: undefined | IEmployeeOption[] = useMemo(
  //   () =>
  //     worktype_employees?.map((employee) => {
  //       return {
  //         email: employee.email,
  //         label: `${employee.fullname} `,
  //         id: employee.id,
  //         avatar: employee.avatar,
  //       };
  //     }),
  //   [worktype_employees]
  // );

  useEffect(() => {
    if (latestSelectedEventData?.employee) {
      let selectedEmployeeOption = employeeOptions?.filter(
        (employeeOption: any) => {
          if (employeeOption?.id === latestSelectedEventData?.employee) {
            return employeeOption;
          }
          return null;
        }
      );
      if (selectedEmployeeOption && selectedEmployeeOption[0])
        setSelectedEmployee(selectedEmployeeOption[0]);
    }
  }, [latestSelectedEventData, setSelectedEmployee, employeeOptions]);

  function handleSelectedEmployee(
    e: React.SyntheticEvent<Element, Event>,
    value: IEmployeeOption | null
  ) {
    if (value) {
      setSelectedEmployee(value);
    } else {
      setSelectedEmployee(null);
    }
  }

  function handleSave() {
    dispatch(
      checkWorkLimit(
        latestSelectedEventData?.id ?? "",
        selectedEmployee?.id ?? ""
      )
    );
  }

  return (
    <Modal
      open={true}
      className=""
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="rostme-modal"
        position="relative"
        sx={{ backgroundColor: "background.paper" }}
      >
        <ModalBoxHeader title={`${titleName}`} handleClose={handleModalClose} />

        <Box className="modal-body">
          <Grid
            container
            alignItems={"center"}
            sx={{
              borderBottom: "1px solid grey ",
              margin: "30px 0",
              padding: "20px 0",
            }}
          >
            <Grid item xs={9}>
              <Box textAlign={"left"}>
                <Typography variant="h6">Detail:</Typography>
                <Typography variant="subtitle1">
                  Fullname:
                  {selectedEmployee?.name ? selectedEmployee.name : "None"}
                </Typography>
                <Typography variant="subtitle1">
                  Email:{" "}
                  {selectedEmployee?.email ? selectedEmployee.email : "None"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Avatar
                sx={{ m: 1, ml: "auto", bgcolor: "primary.main" }}
                src={selectedEmployee?.avatar ?? "/static/images/avatar/1.jpg"}
              >
                <PermIdentityIcon />
              </Avatar>
            </Grid>
          </Grid>
          <Box textAlign={"left"}>
            <Typography variant="h6" my={2}>
              Assign employee:
            </Typography>
            <Grid container>
              <Grid item xs={6}>
                <Autocomplete
                  // disablePortal
                  id="employeeSelect"
                  onChange={(e, value) => handleSelectedEmployee(e, value)}
                  options={employeeOptions ?? []}
                  getOptionLabel={(option) => {
                    return `${option.name}(${option.email})`;
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return option.id === value.id;
                  }}
                  sx={{ width: 300 }}
                  value={selectedEmployee}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select employee"
                      // defaultValue={selectedEmployee?.label}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} display="flex" justifyContent={"flex-end"}>
                <Box sx={{ m: 1, position: "relative" }}>
                  <Button
                    type="submit"
                    form="customfieldform"
                    variant="contained"
                    color="success"
                    startIcon={<SaveIcon />}
                    disabled={selectedEmployee || !loading ? false : true}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
